export class FieldOrder {
    SourceFieldId: string;
    SourceFieldOrder: number;
    DestinationFieldId: string;
    DestinationFieldOrder: number;
}
